/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listCustomerTeamAssignmentsParamsCursorMax = 512;

export const listCustomerTeamAssignmentsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listCustomerTeamAssignmentsParamsLimitDefault = 50;
export const listCustomerTeamAssignmentsParamsLimitMax = 100;

export const ListCustomerTeamAssignmentsParams = zod.object({
  cursor: zod
    .string()
    .min(1)
    .max(listCustomerTeamAssignmentsParamsCursorMax)
    .regex(listCustomerTeamAssignmentsParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(listCustomerTeamAssignmentsParamsLimitMax)
    .default(listCustomerTeamAssignmentsParamsLimitDefault),
});

export type ListCustomerTeamAssignmentsParams = zod.input<typeof ListCustomerTeamAssignmentsParams>;
export type ListCustomerTeamAssignmentsParamsOutput = zod.output<
  typeof ListCustomerTeamAssignmentsParams
>;
